import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface boardItem {
  id: number
  barcode: string
  name: string
}

@Injectable({
  providedIn: 'root'
})

export class BoardService {

  private API_BOARD = "/api/board"
  constructor(private httpClient: HttpClient) { }

  public AddItem(item: any) {
    return this.httpClient.post(this.API_BOARD, item)
  }

  public List() {
    return this.httpClient.get<boardItem[]>(this.API_BOARD)
  }

  public Delete(id: number) {
    return this.httpClient.delete(`${this.API_BOARD}/${id}`)
  }
}
